let injector = (window as any)['injector'];

const getInjector = () => {
  return new Promise((resolve) => {
    const check = () => {
      injector = (window as any)['injector'];
      if (injector) resolve(injector);
      else setTimeout(check, 100);
    };
    check();
  });
};

const inject = (type: any) => {
  return getInjector().then(() => injector.get(type));
};

export { inject };
